/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateFaqDto } from '../../models/lexplus-create-faq-dto';
import { LexplusFaqDetailDto } from '../../models/lexplus-faq-detail-dto';

export interface FaqControllerCreateV1$Params {
      body: LexplusCreateFaqDto
}

export function faqControllerCreateV1(http: HttpClient, rootUrl: string, params: FaqControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFaqDetailDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFaqDetailDto>;
    })
  );
}

faqControllerCreateV1.PATH = '/v1/faq';
